import React from "react";

const DateRangePicker = ({
  startDate = "",
  endDate = "",
  onChange,
  label = "Date Range",
  hint,
  disabled = false,
  className = "",
}) => {
  const handleStartChange = (e) => {
    onChange({ startDate: e.target.value, endDate });
  };

  const handleEndChange = (e) => {
    onChange({ startDate, endDate: e.target.value });
  };

  const handleClear = () => {
    onChange({ startDate: "", endDate: "" });
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-3">
          {label}
        </label>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Start Date
          </label>
          <input
            type="date"
            value={startDate || ""}
            onChange={handleStartChange}
            disabled={disabled}
            className="w-full px-3 py-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            End Date
          </label>
          <input
            type="date"
            value={endDate || ""}
            onChange={handleEndChange}
            disabled={disabled}
            className="w-full px-3 py-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>
      </div>
      {(startDate || endDate) && (
        <button
          type="button"
          onClick={handleClear}
          disabled={disabled}
          className="mt-2 text-xs text-primary-600 hover:text-primary-800 disabled:text-gray-400"
        >
          Clear Dates
        </button>
      )}
      {hint && <p className="text-xs text-gray-500 mt-2">{hint}</p>}
    </div>
  );
};

export default DateRangePicker;
